// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"time_wrapper__LMIdm","label":"time_label__hDz_P","wrapperEnd":"time_wrapperEnd__i7AvN"};